export const BET_EVENT_TYPE = {
  SPORT_PREMATCH: 'PREMATCH',
  SPORT_LIVE: 'LIVE',
  RACING: 'RACING'
}

export const SPORT_SERVICE = {
  LIVE: 'LIVE',
  PREMATCH: 'PREMATCH',
  ARCHIVED: 'ARCHIVED'
}

export const STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  HIDDEN: 'HIDDEN',
  CLOSED: 'CLOSED',
  ABANDONED: 'ABANDONED'
}

export const FEED_STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
}

// Bet Types
export const BET_TYPE = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
  SYSTEM: 'SYSTEM'
}

export const BET_STATUSES = {
  UNSETTLED: 'UNSETTLED',
  LOSE: 'LOSE',
  WIN: 'WIN',
  VOID: 'VOID',
  CASH_OUT: 'CASH_OUT',
  CANCELLED: 'CANCELLED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PENDING_ACCEPT: 'PENDING_ACCEPT',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED'
}

export const BET_INTERCEPT_STATUSES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  PARTIALLY_APPROVED: 'PARTIALLY_APPROVED',
  REJECTED: 'REJECTED'
}

export const REJECTION_REASON = {
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  ODDS_REDUCED: 'ODDS_REDUCED',
  BETTING_CLOSED: 'BETTING_CLOSED',
  PARTIAL_APPROVAL: 'PARTIAL_APPROVAL'
}

export const BETSLIP_VALIDATION_STATUS = {
  WAITING_VALIDATION: 'WAITING_VALIDATION',
  WAITING_REVALIDATION: 'WAITING_REVALIDATION',
  VALIDATING: 'VALIDATING',
  VALIDATION_SUCCEEDED: 'VALIDATION_SUCCEEDED',
  VALIDATION_FAILED: 'VALIDATION_FAILED'
}

export const BONUS_TYPE = {
  DEPOSIT: 'DEPOSIT',
  RELOAD_DEPOSIT: 'RELOAD_DEPOSIT',
  FREEBET_DEPOSIT: 'FREEBET_DEPOSIT',

  NO_DEPOSIT: 'NO_DEPOSIT',
  RELOAD_NO_DEPOSIT: 'RELOAD_NO_DEPOSIT',

  FREEBET: 'FREEBET',
  ODDS_BOOST: 'ODDS_BOOST',
  PROMO_ODDS: 'PROMO_ODDS',
  BET_RETURN: 'BET_RETURN',
  MULTIPLE_BET: 'MULTIPLE_BET',

  BUNDLE: 'BUNDLE'
}

export const BONUS_STATUS = {
  AVAILABLE: 'AVAILABLE',
  ACTIVATED: 'ACTIVATED',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  SPEND: 'SPEND',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  DISABLED: 'DISABLED',
  ACTIVATION_EXPIRED: 'ACTIVATION_EXPIRED',

  WIN: 'WIN',
  LOSE: 'LOSE',
  VOID: 'VOID'
}

// Notification Types
export const NOTIFICATION_TYPE = {
  POPUP: 'popup',
  MESSAGE: 'message',
  CONFIRM: 'confirm'
}

export const ACCEPT_ODDS_CHANGES_TYPES = {
  YES: 'YES',
  NO: 'NO',
  UP: 'UP',
  DOWN: 'DOWN'
}

export const ODDS_FORMAT = {
  DECIMAL: 'decimal',
  FRACTIONAL: 'fractional',
  AMERICAN: 'american',
  HONGKONG: 'hongKong',
  INDONESIAN: 'indonesian',
  MALAY: 'malay'
}

export const THEME_CONTRAST = {
  DARK: 'dark',
  LIGHT: 'light'
}

export const BETSLIP_MODE = {
  DEFAULT: 'default',
  QUICK: 'quick'
}

export const SIDEBAR_ITEMS = {
  RACING: 1,
  SPORTS: 2
}

/*
 * Racing Constants
 */
export const RaceTypeAll = {
  id: 'ALL',
  typeName: 'Today\'s Races'
}

export const RaceTypesMap = {
  HORSE: {
    id: 'HORSE',
    typeName: 'Horses'
  },
  DOG: {
    id: 'DOG',
    typeName: 'Greyhounds'
  },
  TROT: {
    id: 'TROT',
    typeName: 'Harness'
  }
}
export const RaceTypesList = Object.values(RaceTypesMap)

export const RaceMarketsTabs = {
  WP_TAB: 'WP_TAB',
  OWN_TAB: 'OWN_TAB',
  EXTRA: 'EXTRA',
  SAME_RACE_MULTI: 'SAME_RACE_MULTI',
  COMBINED: 'COMBINED',
  QUIN: 'QUIN',
  EXACTA: 'EXACTA',
  TRIFECTA: 'TRIFECTA',
  FIRST4: 'FIRST4'
}

export const RaceLogicMarkets = {
  SAME_RACE_MULTI: 'SAME_RACE_MULTI',
  COMBINED: 'COMBINED',
  QUIN: 'QUIN',
  EXACTA: 'EXACTA',
  TRIFECTA: 'TRIFECTA',
  FIRST4: 'FIRST4'
}

export const RaceMarketsExoticsTabs = {
  EXOTICS: 'EXOTICS',
  QUIN: 'QUIN',
  EXACTA: 'EXACTA',
  TRIFECTA: 'TRIFECTA',
  FIRST4: 'FIRST4'
}

export const RaceMarketsMultilegsTabs = {
  R_DOUBLE: 'R_DOUBLE',
  D_DOUBLE: 'D_DOUBLE',
  TREBLE: 'TREBLE',
  QUADDIE: 'QUADDIE',
  E_QUADDIE: 'E_QUADDIE',
  BIG6: 'BIG6'
}

export const SRM_MARKETS = {
  SRM_WIN_ODDS: 'srmWinOdds',
  SRM_TOP2_ODDS: 'srmTop2Odds',
  SRM_TOP3_ODDS: 'srmTop3Odds',
  SRM_TOP4_ODDS: 'srmTop4Odds'
}

export const SRM_MARKETS_LIST = Object.values(SRM_MARKETS)

/*
 * Use 'betSlipGroup' field in betItem to group bets on betslip UI by type
 */
export const BETSLIP_GROUP = {
  SAME_GAME_MULTI: 'SAME_GAME_MULTI'
}

export const DISPLAY_LAYOUTS = {
  ONE_COLUMN: 'one_column',
  TWO_COLUMNS: 'two_columns',
  THREE_COLUMNS: 'three_columns',
  WINNING_MARGIN: 'winning_margin',
  POINT_WINNER: 'point_winner',
  TWO_COLUMNS_SCORE_SORTED: 'two_columns_score_sorted',
  THREE_COLUMNS_SCORE_SORTED: 'three_columns_score_sorted',
  HANDICAP: 'handicap',
  HANDICAP_DROPDOWN: 'handicap_dropdown',
  NEXT_GOAL: 'next_goal',
  NUMBER_OF_GOALS: 'number_of_goals',
  ODDS_SORTING_TWO_COLUMNS: 'odds_sorting_two_columns',
  ODDS_SORTING_THREE_COLUMNS: 'odds_sorting_three_columns',
  ODDS_SORTING_GROUPED_BY_MARKET: 'odds_sorting_grouped_by_market',
  CRICKET_SEPARATOR: 'cricket_separator',
  GAME_TO_DEUCE: 'game_to_deuce',
  RACE_TO: 'race_to',
  GAME_SCORE: 'game_score',
  THREE_COLUMNS_GROUPED_BY_SPECIFIERS: 'three_columns_grouped_by_specifiers',
  SPEC_DESC_TWO_COLUMNS_SORTED: 'spec_desc_two_columns_sorted',
  TWO_COLUMNS_WINNER_SCORE: 'two_columns_winner_score',
  THREE_COLUMNS_WINNER_SCORE: 'three_columns_winner_score',
  TWO_COLUMNS_GROUPED_BY_MARKET_SPECIFIER_SORTED: 'two_columns_grouped_by_market_specifier_sorted',
  ODDS_SORTING_SPLIT_BY_MARKET: 'odds_sorting_split_by_market'
}
export const LIVECHAT_VISIBILITY = {
  HIDDEN: 'hidden',
  MAXIMIZED: 'maximized',
  MINIMIZED: 'minimized'
}
